<app-normal-navbar></app-normal-navbar>

<div class="cal-wrapper">
  <!-- ── Hero Title Banner ── -->
  <section class="cal-hero-section">
    <div class="cal-hero-bg"></div>
    <div class="cal-hero-glow"></div>
    <div class="cal-hero-container container">
      <div class="cal-hero-header">
        <div class="cal-eyebrow-badge">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          RELEASE TIMELINE
        </div>
        <h1 class="cal-hero-title">SceneTale Release Calendar</h1>
        <p class="cal-hero-subtitle">Explore theatrical premieres, streaming debuts, and upcoming cinematic releases month by month.</p>
      </div>

      <!-- Month Navigation Toolbar -->
      <div class="cal-toolbar">
        <div class="cal-month-display">
          <span class="cal-month-name">{{ monthName }}</span>
          <span class="cal-year">{{ displayYear }}</span>
          <span class="cal-stats-badge" *ngIf="!loading && !error">
            {{ totalReleasesCount }} Premieres
          </span>
        </div>

        <div class="cal-nav-actions">
          <button class="cal-nav-btn" (click)="prevMonth()" aria-label="Previous month" title="Previous Month">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="15 18 9 12 15 6"/></svg>
          </button>
          <button class="cal-today-btn" (click)="goToToday()">Today</button>
          <button class="cal-nav-btn" (click)="nextMonth()" aria-label="Next month" title="Next Month">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- ── Loading State ── -->
  <div *ngIf="loading" class="cal-loading container">
    <div class="loader-ring"></div>
    <p>Loading cinema releases…</p>
  </div>

  <!-- ── Error State ── -->
  <div *ngIf="error" class="cal-error container">
    <p>{{ error }}</p>
    <button class="cal-retry-btn" (click)="loadCalendar()">Try Again</button>
  </div>

  <!-- ── Calendar Grid Section ── -->
  <div *ngIf="!loading && !error" class="cal-body container">
    <!-- Day-of-week headers -->
    <div class="cal-grid cal-grid-header">
      <div *ngFor="let label of dayLabelsList" class="cal-dow">{{ label }}</div>
    </div>

    <!-- Calendar cells -->
    <div class="cal-grid">
      <div
        *ngFor="let day of calendarDays; trackBy: trackByDay"
        class="cal-cell"
        [class.other-month]="!day.isCurrentMonth"
        [class.today]="day.isToday"
        [class.has-movies]="day.movies.length > 0"
        (click)="selectDay(day, $event)"
      >
        <div class="cal-cell-header">
          <span class="cal-cell-date" [class.today-badge]="day.isToday">{{ day.dayOfMonth }}</span>
          <span *ngIf="day.isToday" class="cal-today-dot" title="Today"></span>
        </div>

        <div class="cal-cell-movies" *ngIf="day.movies.length > 0">
          <div
            *ngFor="let movie of day.movies | slice:0:3; trackBy: trackByMovie; let i = index"
            class="cal-cell-poster"
            [class.mobile-hidden]="i > 0"
            (click)="selectMovie(movie, $event)"
            [title]="movie.title + ' (' + (movie.vote_average ? (movie.vote_average * 10 | number:'1.0-0') + '%' : 'NR') + ')'"
          >
            <img
              [src]="posterUrl(movie.poster_path)"
              [alt]="movie.title"
              loading="lazy"
              (error)="onImageError($event)"
            />
          </div>
          <div
            *ngIf="day.movies.length > 3"
            class="cal-cell-overflow-badge desktop-overflow"
            (click)="selectDay(day, $event)"
            [title]="'+' + (day.movies.length - 3) + ' more releases'"
          >
            +{{ day.movies.length - 3 }}
          </div>
          <div
            *ngIf="day.movies.length > 1"
            class="cal-cell-overflow-badge mobile-overflow"
            (click)="selectDay(day, $event)"
            [title]="'+' + (day.movies.length - 1) + ' more releases'"
          >
            +{{ day.movies.length - 1 }}
          </div>
        </div>

        <div class="cal-cell-empty" *ngIf="day.movies.length === 0 && day.isCurrentMonth">
          <span class="cal-cell-ghost"></span>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Upcoming Section ── -->
  <div *ngIf="!loading && !error && upcomingMovies.length > 0" class="cal-upcoming container">
    <div class="cal-section-title">
      <div class="cal-title-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
      </div>
      <h2>Coming Soon to Theaters</h2>
    </div>

    <div class="cal-upcoming-scroll">
      <div class="cal-upcoming-track">
        <div
          *ngFor="let movie of upcomingMovies; trackBy: trackByMovie"
          class="cal-upcoming-card-wrapper"
        >
          <app-media-card [data]="movie" [mediaType]="'movie'"></app-media-card>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Day Releases Modal (When clicking a date with multiple releases) ── -->
  <div class="cal-detail-backdrop" *ngIf="selectedDayMovies && selectedDayMovies.length > 0" (click)="closeDayModal()">
    <div class="cal-day-modal-panel" (click)="$event.stopPropagation()">
      <div class="cal-day-modal-header">
        <div class="cal-day-modal-title">
          <h3>Releases for {{ selectedDayDate | date:'fullDate' }}</h3>
          <span class="cal-stats-badge">{{ selectedDayMovies.length }} Premieres</span>
        </div>
        <button class="cal-detail-close" (click)="closeDayModal()" aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>

      <div class="cal-day-modal-list">
        <div
          *ngFor="let movie of selectedDayMovies; trackBy: trackByMovie"
          class="cal-day-modal-item"
          (click)="selectMovie(movie, $event); closeDayModal()"
        >
          <div class="cal-day-modal-poster">
            <img [src]="posterUrl(movie.poster_path)" [alt]="movie.title" (error)="onImageError($event)" />
          </div>
          <div class="cal-day-modal-info">
            <h4>{{ movie.title }}</h4>
            <div class="cal-day-modal-meta">
              <span class="stars">{{ ratingStars(movie.vote_average) }}</span>
              <span class="score">{{ movie.vote_average | number:'1.1-1' }} / 10</span>
            </div>
            <p class="overview" *ngIf="movie.overview">{{ movie.overview }}</p>
          </div>
          <div class="cal-day-modal-arrow">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Movie Detail Modal ── -->
  <div class="cal-detail-backdrop" *ngIf="selectedMovie" (click)="closeDetail()">
    <div class="cal-detail-panel" (click)="$event.stopPropagation()">
      <button class="cal-detail-close" (click)="closeDetail()" aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>

      <div class="cal-detail-backdrop-img" *ngIf="selectedMovie.backdrop_path">
        <img [src]="backdropUrl(selectedMovie.backdrop_path)" [alt]="selectedMovie.title" />
        <div class="backdrop-gradient-overlay"></div>
      </div>

      <div class="cal-detail-body">
        <div class="cal-detail-poster">
          <img [src]="posterUrl(selectedMovie.poster_path)" [alt]="selectedMovie.title" (error)="onImageError($event)" />
        </div>
        <div class="cal-detail-content">
          <h2 class="cal-detail-title">{{ selectedMovie.title }}</h2>
          <p class="cal-detail-date">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            {{ selectedMovie.release_date | date:'longDate' }}
          </p>
          <p class="cal-detail-rating">
            <span class="stars">{{ ratingStars(selectedMovie.vote_average) }}</span>
            <span class="cal-detail-score">{{ selectedMovie.vote_average | number:'1.1-1' }} / 10</span>
            <span class="cal-detail-votes">({{ selectedMovie.vote_count }} votes)</span>
          </p>
          <p class="cal-detail-overview">{{ selectedMovie.overview }}</p>
          <a [routerLink]="['/movie', selectedMovie.id + '-' + formattedName(selectedMovie.title)]" class="cal-detail-link">
            View Full Movie Details
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
